import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useSocket } from "@/context/SocketContext";

export const READ_EVENT = "velluto:messages-read";

export const useUnreadCount = () => {
  const { user } = useAuth();
  const { addMessageListener } = useSocket();
  const { pathname } = useLocation();
  const [count, setCount] = useState(0);
  const verified = !!user && (user.role === "admin" || user.age_verified);

  const refresh = useCallback(() => {
    if (!verified) return;
    api.get("/messages/unread-count").then(({ data }) => setCount(data.count)).catch(() => {});
  }, [verified]);

  useEffect(() => { refresh(); }, [refresh, pathname]);
  useEffect(() => {
    if (!verified) return undefined;
    const off = addMessageListener((m) => { if (m?.to_user === user.id) setTimeout(refresh, 400); });
    window.addEventListener(READ_EVENT, refresh);
    const poll = setInterval(refresh, 60000);
    return () => { off(); window.removeEventListener(READ_EVENT, refresh); clearInterval(poll); };
  }, [verified, addMessageListener, refresh, user?.id]);

  return verified ? count : 0;
};

export const UnreadBadge = ({ count, testid, className = "" }) => (count > 0 ? (
  <span data-testid={testid} aria-label={`${count} unread`}
    className={`min-w-[18px] h-[18px] px-1 rounded-full bg-gold text-ink text-[10px] font-semibold leading-none flex items-center justify-center shadow-[0_0_10px_rgba(255,214,92,0.6)] ${className}`}>
    {count > 99 ? "99+" : count}
  </span>
) : null);
